import { useState, useEffect } from 'react'
import { Loading, Toast } from 'react-vant'
import { useNavigate } from 'react-router-dom'
import teacherAffairsApi from '../../../api/teacherAffairs'

/** 管理视角的「事务总览」：全校待办 + 本月统计 */
export default function AdminOverview() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [d, setD] = useState({})

  const load = async () => {
    setLoading(true)
    try {
      const res = await teacherAffairsApi.getAdminOverview()
      setD(res?.data || res || {})
    } catch (e) {
      Toast.fail(e.response?.data?.detail || '加载失败')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() }, [])

  const todo = [
    {
      key: 'leave', title: '待审批请假', icon: '✅', color: '#fa8c16',
      value: d.pending_leave_count ?? 0,
      desc: d.pending_leave_teacher_count ? `涉及 ${d.pending_leave_teacher_count} 位教师` : '暂无待审批',
      path: '/teacher/affairs/admin/pending-leave',
    },
    {
      key: 'sub', title: '待安排代课', icon: '🔁', color: '#0891b2',
      value: d.pending_substitute_count ?? 0,
      desc: '需要指派代课教师的课时',
      path: '/teacher/affairs/admin/pending-substitute',
    },
  ]

  const month = [
    { key: 'sick', label: '病假', days: d.leave_sick_days_month ?? 0, color: '#e11d48' },
    { key: 'personal', label: '事假', days: d.leave_personal_days_month ?? 0, color: '#fa8c16' },
    { key: 'other', label: '其他', days: d.leave_other_days_month ?? 0, color: '#64748b' },
  ]
  const totalDays = month.reduce((a, b) => a + b.days, 0)

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      <NavBarSimple title="事务总览" onBack={() => navigate('/teacher/affairs')} />

      <div style={{ padding: '12px 16px 24px' }}>
        {loading ? (
          <div style={{ padding: '40px 0', textAlign: 'center' }}>
            <Loading type="spinner" color="#056b4f">加载中…</Loading>
          </div>
        ) : (
          <>
            {/* 待办 */}
            <SectionTitle text="待办事项" color="#fa8c16" />
            {todo.map(t => (
              <div key={t.key} onClick={() => navigate(t.path)} style={{
                background: '#fff', borderRadius: 12, padding: 14, marginBottom: 10,
                borderLeft: `3px solid ${t.color}`, display: 'flex', alignItems: 'center', gap: 12,
                cursor: 'pointer',
              }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 22, background: t.color + '15',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20,
                }}>{t.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 600, color: '#0f172a' }}>{t.title}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>{t.desc}</div>
                </div>
                <div style={{ fontSize: 22, fontWeight: 700, color: t.color }}>{t.value}</div>
                <span style={{ color: '#cbd5e1', fontSize: 18 }}>›</span>
              </div>
            ))}

            {/* 本月请假 */}
            <SectionTitle text="本月请假（全校）" color="#7c3aed" />
            <div style={{ background: '#fff', borderRadius: 12, padding: 14, marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 12 }}>
                <span style={{ fontSize: 26, fontWeight: 700, color: '#0f172a' }}>{totalDays}</span>
                <span style={{ fontSize: 13, color: '#94a3b8' }}>天</span>
                <span style={{ fontSize: 12, color: '#94a3b8', marginLeft: 'auto' }}>
                  共 {d.teacher_count ?? 0} 位在册教师
                </span>
              </div>
              {month.map(m => (
                <div key={m.key} style={{ marginBottom: 10 }}>
                  <div style={{ display: 'flex', fontSize: 13, color: '#475569', marginBottom: 4 }}>
                    <span>{m.label}</span>
                    <span style={{ marginLeft: 'auto', fontWeight: 600 }}>{m.days} 天</span>
                  </div>
                  <div style={{ height: 6, background: '#f1f5f9', borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{
                      height: '100%', background: m.color, borderRadius: 3,
                      width: totalDays > 0 ? `${Math.max((m.days / totalDays) * 100, m.days > 0 ? 4 : 0)}%` : '0%',
                    }} />
                  </div>
                </div>
              ))}
            </div>

            {/* 本月加班 */}
            <SectionTitle text="本月加班（全校）" color="#00b578" />
            <div style={{
              background: '#fff', borderRadius: 12, padding: 14, marginBottom: 10,
              display: 'flex', alignItems: 'center',
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 4 }}>总时长</div>
                <div style={{ fontSize: 24, fontWeight: 700, color: '#00b578' }}>
                  {d.overtime_hours_month ?? 0}
                  <span style={{ fontSize: 13, fontWeight: 400, color: '#94a3b8', marginLeft: 4 }}>小时</span>
                </div>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 4 }}>参与人数</div>
                <div style={{ fontSize: 24, fontWeight: 700, color: '#0f172a' }}>
                  {d.overtime_teacher_count ?? 0}
                  <span style={{ fontSize: 13, fontWeight: 400, color: '#94a3b8', marginLeft: 4 }}>人</span>
                </div>
              </div>
            </div>

            <div style={{
              fontSize: 12, color: '#94a3b8', lineHeight: 1.7, marginTop: 14,
              background: '#f8fafc', borderRadius: 10, padding: '10px 12px',
            }}>
              · 「事务总览」为全校视角，不含个人事务
              <br />· 完整的事务明细、全员统计与事务设置请在<b>电脑端</b>的「事务管理端」查看
            </div>
          </>
        )}
      </div>
    </div>
  )
}

function SectionTitle({ text, color }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', margin: '4px 0 10px' }}>
      <div style={{ width: 4, height: 14, background: color, borderRadius: 2, marginRight: 8 }} />
      <span style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>{text}</span>
    </div>
  )
}

/** 自绘顶部栏：避免 react-vant NavBar 的 leftArrow 布尔传参坑 */
function NavBarSimple({ title, onBack }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8, padding: '12px 16px',
      background: '#fff', borderBottom: '1px solid #f1f5f9',
    }}>
      <button onClick={onBack} aria-label="返回" style={{
        background: 'none', border: 'none', padding: 0, cursor: 'pointer',
        display: 'flex', alignItems: 'center', color: '#0f172a', fontSize: 20, lineHeight: 1,
      }}>‹</button>
      <span style={{ fontSize: 17, fontWeight: 700, color: '#0f172a' }}>{title}</span>
    </div>
  )
}
